class Timer {
  constructor(options) {
    this.update = options.update;
    this.complete = options.complete;

    if (typeof options.seconds !== 'undefined') {
      const isMarty = $('.tn-logged-in-email').text() === 'mjones@tessituranetwork.com';
      console.warn((isMarty ? 'MARTY JONES!!! ' : '') + 'Please rename `seconds` to `milliseconds` in your usage of tnew.lib.Timer()! We will be removing `seconds` in the future. Thank you!');
      this.milliseconds = options.seconds;
    } else {
      this.milliseconds = options.milliseconds;
    }
  }

  isUrgent(seconds) {
    return seconds <= 120;
  }

  restart(milliseconds) {
    this.milliseconds = milliseconds;
    this.start();
  }

  format(seconds) {
    let hours = 0;
    let minutes = 0;

    if (seconds >= (3600)) {
      hours = Math.floor(seconds / 3600);
      seconds %= 3600;
    }

    if (seconds >= 60) {
      minutes = Math.floor(seconds / 60);
      seconds %= 60;
    }

    if (hours > 0) {
      if (hours < 10) {
        hours = `0${hours}:`;
      }
    } else {
      hours = '';
    }

    if (minutes > 9) {
      minutes += ':';
    } else {
      minutes = `0${minutes}:`;
    }

    if (seconds < 10) {
      seconds = `0${seconds}`;
    }

    return hours + minutes + seconds;
  }

  start() {
    const start = new Date().getTime();
    const interval = setInterval(() => {
      const now = this.milliseconds - (new Date().getTime() - start);
      if (now <= 0) {
        clearInterval(interval);

        if (this.complete) {
          this.complete();
        }
      } else {
        const secondsRemaining = Math.floor(now / 1000);
        if (this.update) {
          this.update(this.format(secondsRemaining), secondsRemaining);
        }
      }
    }, 100);
  }

}


export default Timer;



// WEBPACK FOOTER //
// ./V7/tnew/lib/Timer.js